// The health endpoint proxies a per-process cache that itself refreshes on a
// short cycle server-side; polling faster than this would only show the same
// cached values more often.
export const HEALTH_POLL_INTERVAL_MS = 10000;

// `servicesCheckedAt` is a unix timestamp in seconds, and queue ages are in
// seconds; the rest of the app works with `Date`/milliseconds.
export const UNIX_SECONDS_TO_MS = 1000;
export const SECONDS_TO_MS = 1000;

// The dedicated Fair Queue page already renders the per-tenant breakdown and
// the live throttling state, so this page links to it instead of duplicating
// its cards.
export const FAIR_QUEUE_ROUTE = '/internal-admin/fair-queue';

export const CLIENTS_ROUTE = '/internal-admin/clients';

// Past this, a waiting job is no longer normal scheduling jitter: it is the
// threshold the capacity alarm watches.
export const BACKLOG_AGE_ALERT_SECONDS = 120;

// The engine kills a run at its timeout, so a job still active at twice the
// longest one is a slot that will never free on its own.
export const STUCK_ACTIVE_JOB_TIMEOUT_MULTIPLIER = 2;

// Past this, a worker is no longer comfortably absorbing its load.
export const RESOURCE_ALERT_PERCENT = 85;

// A probe answering slower than this is degraded, even if it answers.
export const SLOW_PROBE_MS = 1000;

export const BYTES_PER_MIB = 1024 ** 2;
export const BYTES_PER_GIB = 1024 ** 3;
